/** An ambiguous POST is reconciled by a safe history read, never automatically
 * repeated. A successful mutation remains accepted even if that read is offline. */
export async function restoreWithReconciliation(ports:{valid:()=>boolean;send:()=>Promise<void>;refresh:()=>Promise<void>;restored:()=>boolean}):Promise<'stale'|'accepted'|'restored'>{
 if(!ports.valid())return 'stale';
 let failed=false,failure:unknown;
 try{await ports.send();}catch(error){failed=true;failure=error;}
 if(!ports.valid())return 'stale';
 try{await ports.refresh();}catch{/* The mutation outcome is retained below. */}
 if(!ports.valid())return 'stale';
 if(ports.restored())return 'restored';
 if(failed)throw failure;
 return 'accepted';
}
